import { memo } from 'react'
import Grid from '@mui/material/Grid'
import { useTheme, useMediaQuery, Skeleton, Theme } from '@mui/material'
import useEmotionStyles from 'hooks/useEmotionStyles'
import Divider from '../Footer/Divider'

const styles = (theme: Theme) => ({
  container: {
    padding: theme.spacing(2),
    maxWidth: '1200px',
    margin: '0 auto'
  }
})

const FooterWithBoxesSkeleton = () => {
  const { container } = useEmotionStyles(styles)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <>
      <Divider />
      <div className={container}>
        <Grid container spacing={3} direction={isMobile ? 'column' : 'row'}>
          {[...Array(4)].map((_, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <Grid item xs={12} sm={6} md={3} key={`grid-boxes-index-${i}`}>
              <Skeleton
                variant="rectangular"
                width="100%"
                height={isMobile ? 56 : 144}
              />
            </Grid>
          ))}
        </Grid>
      </div>
      <Divider />
      <div className={container}>
        <Grid container spacing={3} direction={isMobile ? 'column' : 'row'}>
          {[...Array(3)].map((_, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <Grid item xs={4} key={`grid-lower-boxes-index-${i}`}>
              <Skeleton variant="rectangular" width="100%" height={64} />
            </Grid>
          ))}
        </Grid>
      </div>
      <Divider />
    </>
  )
}

export default memo(FooterWithBoxesSkeleton)
